var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"narrowContainer"},[_c('LoginAndRegister',{attrs:{"action":_vm.action,"redirect":_vm.redirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }